export const MODAL_TOGGEL_OPEN = "MODAL_TOGGEL_OPEN" 
export const MODAL_TOGGEL_CLOSE = "MODAL_TOGGEL_CLOSE"